import fetch from '../fetch'

export default (lang: string) => {
  return fetch({
    method: 'GET',
    path: `api/v1/lookup/countries`,
    headers: {
      'Accept-Language': lang,
    },
  })
}
